const HourGlass = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M37.375 97.75H100.625M69 69C59.85 69 51.0748 72.6348 44.6048 79.1048C38.1348 85.5748 34.5 94.35 34.5 103.5V115C34.5 116.525 35.1058 117.988 36.1841 119.066C37.2625 120.144 38.725 120.75 40.25 120.75H97.75C99.275 120.75 100.738 120.144 101.816 119.066C102.894 117.988 103.5 116.525 103.5 115V103.5C103.5 94.35 99.8652 85.5748 93.3952 79.1048C86.9252 72.6348 78.15 69 69 69ZM69 69C59.85 69 51.0748 65.3652 44.6048 58.8952C38.1348 52.4252 34.5 43.65 34.5 34.5V23C34.5 21.475 35.1058 20.0125 36.1841 18.9341C37.2625 17.8558 38.725 17.25 40.25 17.25L97.75 17.25C99.275 17.25 100.738 17.8558 101.816 18.9341C102.894 20.0125 103.5 21.475 103.5 23V34.5C103.5 43.65 99.8652 52.4252 93.3952 58.8952C86.9252 65.3652 78.15 69 69 69Z"
            stroke="#F3CBE7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default HourGlass;
